export const setSessionStorage = (key: string, val: any): void => {
  if (!key) {
    console.error("setSessionStorage: Key is required.");
    return;
  }
  if (typeof sessionStorage === "undefined") {
    console.error("setSessionStorage: sessionStorage is not available.");
    return;
  }

  try {
    // Convert value to JSON string (including undefined/null handling)
    const stringValue = JSON.stringify(val);
    sessionStorage.setItem(key, stringValue);
  } catch (e) {
    console.error("setSessionStorage: Failed to set item", e);
  }
};

export const getSessionStorage = <T = any>(key: string): T | null => {
  if (!key) {
    console.error("getSessionStorage: Key is required.");
    return null;
  }
  if (typeof sessionStorage === "undefined") {
    console.error("getSessionStorage: sessionStorage is not available.");
    return null;
  }

  const val = sessionStorage.getItem(key);
  if (!val) return null;

  try {
    // Parse JSON string back to original data
    return JSON.parse(val) as T;
  } catch (e) {
    console.warn("getSessionStorage: Failed to parse item. Returning raw string.", e);
    return val as unknown as T; // Return raw string if JSON parse fails
  }
};

export const removeSessionStorageItem = (key: string): void => {
  if (!key) {
    console.error("removeSessionStorageItem: Key is required.");
    return;
  }
  if (typeof sessionStorage === "undefined") {
    console.error("removeSessionStorageItem: sessionStorage is not available.");
    return;
  }

  const val = sessionStorage.getItem(key);
  if (!val) {
    console.warn(`removeSessionStorageItem: Key '${key}' does not exist.`);
  }
  sessionStorage.removeItem(key);
};

export const removeAllSessionStorage = (): void => {
  if (typeof sessionStorage === "undefined") {
    console.error("removeAllSessionStorage: sessionStorage is not available.");
    return;
  }

  sessionStorage.clear();
};
